import enTranslations from './locales/en.json'
import type { Translations, Language } from './types'

/**
 * Available translations
 */
const translations: Record<Language, Translations> = {
  en: enTranslations,
}

/**
 * Get translation for a given language
 */
export function getTranslations(language: Language = 'en'): Translations {
  return translations[language] || translations.en
}

/**
 * Get nested translation value by path
 * Example: getTranslation('login.form.emailLabel', 'en')
 * 
 * @param path - Dot-separated path to translation key (e.g., 'login.form.emailLabel')
 * @param language - Language code (defaults to 'en')
 * @returns Translated string or the path if translation not found
 */
export function getTranslation(
  path: string,
  language: Language = 'en'
): string {
  if (!path || typeof path !== 'string') {
    console.warn('Invalid translation path provided:', path)
    return path || ''
  }

  const keys = path.split('.').filter(Boolean)
  if (keys.length === 0) {
    console.warn('Empty translation path provided')
    return path
  }

  const translations = getTranslations(language)
  
  let value: unknown = translations
  for (const key of keys) {
    if (value && typeof value === 'object' && key in value) {
      value = (value as Record<string, unknown>)[key]
    } else {
      if (import.meta.env.DEV) {
        console.warn(`Translation key not found: ${path} (language: ${language})`)
      }
      return path
    }
  }
  
  if (typeof value === 'string') {
    return value
  }
  
  // If value is not a string, return the path as fallback
  if (import.meta.env.DEV) {
    console.warn(`Translation value is not a string for path: ${path}`)
  }
  return path
}

